import { render, staticRenderFns } from "./LineItem.vue?vue&type=template&id=4622dbc1&scoped=true&"
import script from "./LineItem.vue?vue&type=script&lang=js&"
export * from "./LineItem.vue?vue&type=script&lang=js&"
import style0 from "./LineItem.vue?vue&type=style&index=0&id=4622dbc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4622dbc1",
  null
  
)

export default component.exports